import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';

import { useState, useRef, useEffect, memo } from 'react';
import { useCallback } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import attach2Fill from '@iconify/icons-eva/attach-2-fill';
import roundThumbUp from '@iconify/icons-ic/round-thumb-up';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
import moreHorizontalFill from '@iconify/icons-eva/more-horizontal-fill';
// material
import Swal from 'sweetalert2'
import { MobileDateRangePicker, LoadingButton } from '@material-ui/lab';


import { styled } from '@material-ui/core/styles';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import {
    Box,
    Stack,
    Drawer,
    Button,
    Avatar,
    Tooltip,
    Divider,
    MenuItem,
    TextField,
    Typography,
    OutlinedInput,
    Grid,
    Card,
    Tabs,
    Tab,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Link,
    InputBase,
    IconButton
} from '@material-ui/core';
//

import { MIconButton, MHidden } from '../../../components/@material-extend';
import apiContact from '../../../api/contact';
import apiUser from '../../../api/user';
import { useSnackbar } from 'notistack5';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------
import useAuth from '../../../hooks/useAuth'
import { objectID } from '../../../utils/objectID';
import { useSelector } from 'react-redux';

import { capitalCase } from 'change-case';
import Scrollbar from '../../../components/Scrollbar';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FTicket from '../form/FTicket';
import FStaff from '../form/FStaff';
import FCustomer from '../form/FCustomer';
import FUpload from '../form/FUpload';
import apiTicket from '../../../api/ticket';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import SendIcon from '@mui/icons-material/Send';
import MenuPopover from '../../../components/MenuPopover';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
const PRIORITIZES = [
    {
        level: 'low',
        level_name: "Thấp"
    },
    {
        level: 'medium',
        level_name: "Vừa"
    },
    {
        level: 'high',
        level_name: "Cao"
    },
];


const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.body2,
    width: 140,
    fontSize: 13,
    flexShrink: 0,
    color: theme.palette.text.secondary
}));

const theme = createTheme({
    palette: {
        voip: {
            main: "#303187",
            contrastText: "#fff"
        },
    }
});

// ----------------------------------------------------------------------

export default memo(function FormActionTicket({ isOpen, onClose, selectedTicket, setRefreshTicket, isReadOnly, taskCompleted, setTaskCompleted, quickInfoContactAdd }) {

    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const { user } = useAuth();
    const [listUser, setListUser] = useState([]);
    const [comment, setComment] = useState("");
    const [commentReply, setCommentReply] = useState("");
    const [commentEdit, setCommentEdit] = useState("");
    const [statusReply, setStatusReply] = useState({});
    const [selectedCommentEdit, setSelectedCommentEdit] = useState("");
    const anchorRef = useRef();
    const [comments, setComments] = useState([]);
    const [open, setOpen] = useState(false);
    const [validation, setValidation] = useState({
        project_name: Yup.string().required('Tên công việc không được bỏ trống!'),
        project_type: Yup.string().required('Loại công việc không được bỏ trống!'),
        project_priority: Yup.string().required('Độ ưu tiên không được bỏ trống!'),
        //project_content: Yup.string().required('Nội dung công việc không được bỏ trống!'),
        support_dept: Yup.string().required('Bộ phận hỗ trợ không được bỏ trống!'),
        // date_start: Yup.string().required('Ngày bắt đầu không được bỏ trống!'),
        // date_end: Yup.string().required('Ngày kết thúc không được bỏ trống!'),
        designator_id: Yup.string().required('Người chỉ định không được bỏ trống!'),
        reciever_id: Yup.string().required('Người nhận không được bỏ trống!'),
        customer_name: Yup.string().required('Tên khách hàng không được bỏ trống!'),
        customer_phone: Yup.string().required('SĐT khách hàng không được bỏ trống!'),
        //customer_email: Yup.string().required('Mail khách hàng không được bỏ trống!'),

    });
    const [customer, setCustomer] = useState({ nameProfile: "Phuongtest", role: "Programmer" });

    const onDeleteTask = async (ticket_id) => {
        try {
            const ticket_info = await apiTicket.delete_force({ ticket_id: ticket_id });
            enqueueSnackbar("Thành công", { variant: 'success' });
            setRefreshTicket(true);
        } catch (error) {
            enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        }
    }


    const handleToggleCompleted = () => {
        const taskCompletedCurrent = !taskCompleted;
        if (selectedTicket.status == "completed") {
            Swal.fire(
                'Error!',
                "Không thể hoàn tác ghi phiếu ghi đã hoàn thành",
                'error'
            );
        } else {
            if (taskCompletedCurrent) {
                Swal.fire({
                    title: "Xác nhận hoàn thành phiếu ghi?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: '#ffc107',
                    confirmButtonText: "Xác nhận",
                    cancelButtonText: "Hủy bỏ",
                    showLoaderOnConfirm: true,
                }).then(async function (result) {
                    if (result.isConfirmed) {
                        setTaskCompleted((prev) => !prev);
                        setFieldValue('status', taskCompletedCurrent ? 'completed' : 'progress');
                    }
                })
            } else {
                setTaskCompleted((prev) => !prev);
                setFieldValue('status', taskCompletedCurrent ? 'completed' : 'progress');
            }
        }

    };
    const handleChangePrioritize = (event) => {
        setFieldValue(event.target.name, event.target.value)
    };
    const onHandleChangeInputComment = (e) => {
        setComment(e.target.value)
    }
    const onHandleChangeInputCommentReply = (e) => {
        setCommentReply(e.target.value)
    }
    const load_comment = async () => {
        try {
            const res_load_comment = await apiTicket.comments({ ticket_id: objectID(selectedTicket._id) })
            setComment("");

            setCommentEdit("")
            setStatusReply({})
            setSelectedCommentEdit("")
            setComments(res_load_comment.data.data)
        } catch (error) { }
    }

    const sendComment = async (parent_id) => {
        try {
            const res_send_comment = await apiTicket.send_comment({ ticket_id: objectID(selectedTicket._id), comment: comment, parent_id: parent_id, comment_reply: commentReply });
            setComment("");
            setCommentReply("");

            load_comment();

        } catch (error) {
            enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        }
    }

    const handleClose = () => {
        setOpen(false)
    }
    const handleOpen = () => {
        setOpen(true)
    }
    const handleKeyUp = (e, comment_id) => {

        if (e.key === 'Enter') {
            sendComment(comment_id ? objectID(comment_id) : null);
        }
    };
    const handleKeyUpEdit = (e, ticket_id, comment_id) => {

        if (e.key === 'Enter') {
            editComment(ticket_id, comment_id)
        }
    };

    const initialValues = {
        project_name: selectedTicket?.project_name,
        project_type: selectedTicket?.project_type || "",
        project_priority: selectedTicket?.project_priority || "low",
        project_content: selectedTicket?.project_content || "",
        support_dept: selectedTicket?.support_dept || user?.department_id,
        date_start: selectedTicket?.date_start || "",
        date_end: selectedTicket?.date_end || "",
        designator_id: selectedTicket?.designator_id || user.id,
        reciever_id: selectedTicket?.reciever_id || "",
        reciever_content: selectedTicket?.reciever_content || "",
        customer_name: selectedTicket?.customer_name || quickInfoContactAdd?.name || "",
        customer_phone: selectedTicket?.customer_phone || quickInfoContactAdd?.phone || "",
        customer_email: selectedTicket?.customer_email || quickInfoContactAdd?.email || "",
        status: selectedTicket?.status || "waiting",
        remind_in: selectedTicket?.remind_in || "",
        

    }

    const NewTicketSchema = Yup.object().shape(validation);
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: NewTicketSchema,
        onSubmit: async (values, { setSubmitting, resetForm, setErrors, setFieldValue }) => {
            try {

                if (selectedTicket) {
                    values.status_ticket = taskCompleted;
                    values.ticket_id = objectID(selectedTicket._id);
                    const res_add = await apiTicket.edit(values);
                    enqueueSnackbar("Cập nhật thành công", { variant: 'success' });
                    resetForm();
                    // setFieldValue('designator_id', objectID(user._id))
                    // setFieldValue('reciever_id', "");
                    setRefreshTicket(true);
                    onClose();

                } else {
                    values.status_ticket = taskCompleted;
                    const res_add = await apiTicket.add(values)
                    enqueueSnackbar("Tạo thành công", { variant: 'success' });
                    resetForm();
                    // setFieldValue('designator_id', objectID(user._id));
                    // setFieldValue('reciever_id', "");
                    setRefreshTicket(true);
                    onClose();

                }

            } catch (error) {
                enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
                // if (error.response.data.message[0] === "Đã tồn tại danh bạ") {
                //   const res_info_contact = await apiContact.find(values);
                //   setInfoContactSelected(res_info_contact.data.data);
                //   setOpenDialog(true);
                // }
            }

        }
    });
    const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps, resetForm } = formik;
    useEffect(() => {
        const loadListUser = async () => {
            const res_list_user = await apiUser.view({ department_id: values.support_dept });
            setListUser(res_list_user.data.data);
        }
        if (values?.support_dept) {
            loadListUser();
        }
    }, [values.support_dept]);
    useEffect(() => {
        if (selectedTicket) {
            load_comment();
        }
    }, [selectedTicket]);
    const editComment = async (ticket_id, comment_id) => {
        try {
            const res_edit_comment = await apiTicket.edit_comment({ ticket_id: ticket_id, comment_id: comment_id, comment: commentEdit });
            load_comment();
        } catch (error) {
            enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        }

    }
    const deleteComment = async (comment_id) => {
        try {
            const res_delete_comment = await apiTicket.delete_comment({ comment_id: comment_id });
            load_comment();
        } catch (error) {
            enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        }
    }
    const onHandleChangeInputCommentEdit = async (e) => {
        setCommentEdit(e.target.value)
    }
    const onCancelCommentEdit = () => {
        setCommentEdit("")
        setSelectedCommentEdit("")
    }

    return (
        <>
            <Drawer open={isOpen} onClose={onClose} anchor="right" PaperProps={{ sx: { width: { xs: 1, sm: 1280 } } }}>
                <FormikProvider value={formik}>
                    <Form noValidate autoComplete="off" onSubmit={handleSubmit} >
                        <Stack p={2.5} direction="row" alignItems="center" spacing={1}>
                            <MHidden width="smUp">
                                <Tooltip title="Back">
                                    <MIconButton onClick={() => onClose()} sx={{ mr: 1 }}>
                                        <Icon icon={arrowIosBackFill} width={20} height={20} />
                                    </MIconButton>
                                </Tooltip>
                            </MHidden>

                            {selectedTicket ? <Button

                                size="medium"
                                variant={taskCompleted ? 'text' : 'contained'}
                                color={taskCompleted ? 'success' : 'inherit'}
                                sx={{ p: 0.8 }}
                                startIcon={<Icon icon={checkmarkFill} width={16} height={16} />}
                                onClick={() => handleToggleCompleted()}
                            >
                                {taskCompleted ? 'Đã Hoàn thành' : 'đánh dấu hoàn thành'}
                            </Button> : null}
                            <Stack direction="row" alignItems="center" justifyContent="center">
                                <TextField
                                    size='small'
                                    variant='outlined'
                                    fullWidth
                                    select
                                    value={values.project_priority}
                                    name='project_priority'
                                    onChange={handleChangePrioritize}
                                    sx={{
                                        '& svg': { display: 'none' },
                                        // '& fieldset': { display: 'none' },
                                        '& .MuiSelect-select': { justifyContent: "center", display: 'flex', alignItems: 'center' }
                                    }}
                                    error={Boolean(touched.project_priority && errors.project_priority)}
                                    helperText={touched.project_priority && errors.project_priority}
                                >
                                    {PRIORITIZES.map((option) => (
                                        <MenuItem key={option} value={option.level}>
                                            <Box
                                                sx={{
                                                    mr: 1,
                                                    width: 14,
                                                    height: 14,
                                                    borderRadius: 0.5,
                                                    bgcolor: 'error.main',
                                                    ...(option.level === 'low' && { bgcolor: 'info.main' }),
                                                    ...(option.level === 'medium' && { bgcolor: 'warning.main' })
                                                }}
                                            />
                                            <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>
                                                {option.level_name}
                                            </Typography>
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Stack>
                            <Stack direction="row" spacing={1} justifyContent="flex-end" flexGrow={1}>
                                {(selectedTicket && selectedTicket.status !== "completed") || !selectedTicket ? <ThemeProvider theme={theme}>
                                    <Button onClick={handleSubmit} variant='contained' size='small' color="voip" startIcon={selectedTicket ? <Icon icon="radix-icons:update" /> : <Icon icon="mi:add" />} > {selectedTicket ? "Cập nhật" : "Tạo mới"}</Button>
                                </ThemeProvider> : null}

                                {selectedTicket ? <Tooltip title="Delete task">
                                    <MIconButton onClick={() => onDeleteTask(objectID(selectedTicket?._id))} size="small">
                                        <Icon icon={trash2Outline} width={20} height={20} color="#ff5e5e" />
                                    </MIconButton>
                                </Tooltip> : null}
                            </Stack>
                        </Stack>

                        <Divider />
                        <Paper>

                            <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item xs={8}>
                                    <Stack sx={{ p: 1 }} direction={"column"} spacing={2}>
                                        <Accordion defaultExpanded={true}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography sx={{ color: '#303187', fontSize: '16px', fontWeight: '700', lineHeight: '20px', letterSpacing: '-0.32px' }} align='center'>THÔNG TIN TICKET</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <FTicket selectedTicket={selectedTicket} isReadOnly={isReadOnly} listUser={listUser} formik={formik}> </FTicket>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Stack direction={"row"} gap={1}>
                                            <Accordion
                                                sx={{
                                                    width: "50%",
                                                    "&.Mui-expanded": {
                                                        margin: "0 0"
                                                    }
                                                }}
                                                defaultExpanded={true}

                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography sx={{ color: '#303187', fontSize: '16px', fontWeight: '700', lineHeight: '20px', letterSpacing: '-0.32px' }} align='center'>THÔNG TIN TIẾP NHẬN</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <FStaff selectedTicket={selectedTicket} isReadOnly={isReadOnly} listUser={listUser} formik={formik}></FStaff>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                sx={{
                                                    width: "50%",
                                                    "&.Mui-expanded": {
                                                        margin: "0 0"
                                                    }
                                                }}
                                                defaultExpanded={true}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Stack>
                                                        <Typography sx={{ color: '#303187', fontSize: '16px', fontWeight: '700', lineHeight: '20px', letterSpacing: '-0.32px' }} align='center'>THÔNG TIN KHÁCH HÀNG </Typography>
                                                    </Stack>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <FCustomer isReadOnly={isReadOnly} formik={formik} selectedTicket={selectedTicket} quickInfoContactAdd={quickInfoContactAdd}></FCustomer>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Stack>
                                        <Accordion defaultExpanded={true}>

                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                {selectedTicket?.url_file_upload && <Typography align='left'>
                                                    <a
                                                        href={selectedTicket?.url_file_upload}
                                                        download={selectedTicket?.url_file_upload.split('/').pop()}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <Button variant='outlined' startIcon={<Icon icon="material-symbols:download" />}>Tải file đính kèm</Button>
                                                    </a>
                                                </Typography>}
                                                <Typography sx={{ color: '#303187', fontSize: '16px', fontWeight: '700', lineHeight: '20px', letterSpacing: '-0.32px' }} align='center'>UPLOAD FILE ĐÍNH KÈM</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <FUpload isReadOnly={isReadOnly} formik={formik}></FUpload>
                                            </AccordionDetails>
                                        </Accordion>

                                    </Stack >
                                </Grid>

                                <Grid item xs={4}>
                                    <Stack sx={{ px: 1 }} direction={"column"} spacing={2}>
                                        <Accordion defaultExpanded={true}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >

                                                <Typography sx={{ color: '#303187', fontSize: '16px', fontWeight: '700', lineHeight: '20px', letterSpacing: '-0.32px' }} align='center'>GHI CHÚ CÔNG VIỆC</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>

                                                {selectedTicket ?
                                                    <>
                                                        <Scrollbar sx={{ px: 1, flexGrow: 1, height: "75vh" }}>

                                                            <Stack direction={"column"} sx={{ p: 1 }} spacing={1}>
                                                                {comments.map(iComment => {
                                                                    return (
                                                                        <Paper sx={{
                                                                            "&:hover": {
                                                                                [`.c${objectID(iComment._id)}`]: {
                                                                                    display: "block"
                                                                                }
                                                                            },
                                                                            p: 1
                                                                        }}
                                                                            elevation={3}
                                                                        >
                                                                            <Box display={"flex"} justifyContent={"space-between"}>
                                                                                <Typography variant="subtitle2" color="green">{iComment.created_name}</Typography>
                                                                                <Stack sx={{ display: "none" }} direction={"row"} spacing={0.5} className={`c${objectID(iComment._id)}`}>
                                                                                    <IconButton size="small" onClick={() => setSelectedCommentEdit(objectID(iComment._id))} color="primary" aria-label="directions">
                                                                                        <EditIcon fontSize='0.5rem' />
                                                                                    </IconButton>
                                                                                    <IconButton size="small" onClick={() => deleteComment(objectID(iComment._id))} color="primary" aria-label="directions">
                                                                                        <DeleteIcon fontSize='0.5rem' />
                                                                                    </IconButton>
                                                                                </Stack>
                                                                            </Box>
                                                                            {
                                                                                selectedCommentEdit === objectID(iComment._id) ?
                                                                                    <Paper elevation={5} sx={{ mt: 1, display: "flex", alignItems: 'center', }}>
                                                                                        <InputBase sx={{ ml: 1, flex: 1 }}
                                                                                            size="small"
                                                                                            defaultValue={iComment.comment}
                                                                                            onChange={onHandleChangeInputCommentEdit}
                                                                                            onKeyUp={e => handleKeyUpEdit(e, iComment.ticket_id, objectID(iComment._id))}
                                                                                            placeholder="Nhập nội dung để chỉnh sửa"
                                                                                            inputProps={{ 'aria-label': 'Nhập nội dung để chỉnh sửa' }}> </InputBase>
                                                                                        <IconButton onClick={() => editComment(iComment.ticket_id, objectID(iComment._id))} disabled={commentEdit != "" ? false : true} color="primary" sx={{ p: '10px' }} aria-label="directions">
                                                                                            <SendIcon />
                                                                                        </IconButton>
                                                                                        <IconButton onClick={() => onCancelCommentEdit()} color="primary" sx={{ p: '10px' }} aria-label="directions">
                                                                                            <CancelIcon />
                                                                                        </IconButton>
                                                                                    </Paper> :
                                                                                    <Typography sx={{ wordWrap: "break-word" }} variant="body2">{iComment.comment}</Typography>
                                                                            }

                                                                            <Stack
                                                                                direction={"row"}
                                                                                spacing={2}
                                                                                justifyContent={"space-between"}

                                                                            >
                                                                                <Typography onClick={() => setStatusReply({ id: objectID(iComment._id) })} variant="body2" color="#303187"
                                                                                    sx={{ cursor: "pointer", "&:hover": { textDecorationLine: "underline", textDecorationColor: "#303187" } }} >Trả lời</Typography>
                                                                                <Typography fontSize="0.8rem" color="GrayText" variant="body2">{iComment.created_at}</Typography>

                                                                            </Stack>
                                                                            {iComment?.child_comment.map(cComment => {
                                                                                return (
                                                                                    <Paper
                                                                                        sx={{
                                                                                            "&:hover": {
                                                                                                [`.i${objectID(cComment._id)}`]: {
                                                                                                    display: "block"
                                                                                                }
                                                                                            },
                                                                                            mt: 1,
                                                                                            ml: 2,
                                                                                            p: 1

                                                                                        }}
                                                                                        elevation={0} >

                                                                                        <Box display={"flex"} justifyContent={"space-between"}>
                                                                                            <Typography variant="subtitle2" color="green">{cComment.created_name}</Typography>
                                                                                            <Stack sx={{ display: "none" }} direction={"row"} spacing={0.5} className={`i${objectID(cComment._id)}`}>
                                                                                                <IconButton size="small" onClick={() => setSelectedCommentEdit(objectID(cComment._id))} color="primary" aria-label="directions">
                                                                                                    <EditIcon fontSize='0.5rem' />
                                                                                                </IconButton>
                                                                                                <IconButton size="small" onClick={() => deleteComment(objectID(cComment._id))} color="primary" aria-label="directions">
                                                                                                    <DeleteIcon fontSize='0.5rem' />
                                                                                                </IconButton>
                                                                                            </Stack>
                                                                                        </Box>
                                                                                        {
                                                                                            selectedCommentEdit === objectID(cComment._id) ?
                                                                                                <Paper elevation={5} sx={{ mt: 1, display: "flex", alignItems: 'center', }}>
                                                                                                    <InputBase sx={{ ml: 1, flex: 1 }}
                                                                                                        size="small"
                                                                                                        defaultValue={cComment.comment}
                                                                                                        onKeyUp={e => handleKeyUpEdit(e, cComment.ticket_id, objectID(cComment._id))}
                                                                                                        onChange={onHandleChangeInputCommentEdit}
                                                                                                        placeholder="Nhập nội dung để chỉnh sửa"
                                                                                                        inputProps={{ 'aria-label': 'Nhập nội dung để chỉnh sửa' }}> </InputBase>
                                                                                                    <IconButton onClick={() => editComment(cComment.ticket_id, objectID(cComment._id))} disabled={commentEdit != "" ? false : true} color="primary" sx={{ p: '10px' }} aria-label="directions">
                                                                                                        <SendIcon />
                                                                                                    </IconButton>
                                                                                                    <IconButton onClick={() => onCancelCommentEdit()} color="primary" sx={{ p: '10px' }} aria-label="directions">
                                                                                                        <CancelIcon />
                                                                                                    </IconButton>
                                                                                                </Paper> :
                                                                                                <Typography sx={{ wordWrap: "break-word" }} variant="body2">{cComment.comment}</Typography>

                                                                                        }
                                                                                        <Stack direction={"row"} spacing={2} justifyContent={"space-between"}>
                                                                                            <Typography onClick={() => setStatusReply({ id: objectID(iComment._id) })} variant="body2" color="#303187"
                                                                                                sx={{ cursor: "pointer", "&:hover": { textDecorationLine: "underline", textDecorationColor: "#303187" } }} >Trả lời</Typography>
                                                                                            <Typography fontSize="0.8rem" color="GrayText" variant="body2">{iComment.created_at}</Typography>
                                                                                        </Stack>
                                                                                    </Paper>
                                                                                )
                                                                            })}
                                                                            {
                                                                                statusReply.id === objectID(iComment._id) && <Paper elevation={0} sx={{ mt: 1, display: "flex", alignItems: 'center', }}>
                                                                                    <InputBase sx={{ ml: 1, flex: 1 }}
                                                                                        size="small"
                                                                                        value={commentReply}

                                                                                        onChange={onHandleChangeInputCommentReply}
                                                                                        onKeyUp={e => handleKeyUp(e, iComment._id)}
                                                                                        placeholder="Nhập và ấn Enter để gửi 2"
                                                                                        inputProps={{ 'aria-label': 'Nhập và ấn Enter để gửi 2' }}> </InputBase>
                                                                                    <IconButton onClick={() => sendComment(objectID(iComment._id))} disabled={commentReply != "" ? false : true} color="primary" sx={{ p: '10px' }} aria-label="directions">
                                                                                        <SendIcon />
                                                                                    </IconButton>
                                                                                </Paper>
                                                                            }
                                                                        </Paper>

                                                                    )

                                                                })}


                                                            </Stack>
                                                        </Scrollbar>

                                                        <Paper elevation={0} sx={{ mt: 1, display: "flex", alignItems: 'center', justifyContent: "space-between" }}>
                                                            <InputBase sx={{ ml: 1, flex: 1 }}
                                                                size="small"
                                                                value={comment}
                                                                onChange={onHandleChangeInputComment}
                                                                onKeyUp={e => handleKeyUp(e, null)}
                                                                placeholder="Nhập và ấn Enter để gửi"
                                                                inputProps={{ 'aria-label': 'Nhập và ấn Enter để gửi' }}> </InputBase>
                                                            <IconButton onClick={() => sendComment()} disabled={comment != "" ? false : true} color="primary" sx={{ p: '10px' }} aria-label="directions">
                                                                <SendIcon />
                                                            </IconButton>
                                                            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                                        </Paper></>
                                                    : <Typography>Bạn vui lòng tạo ticket mới có thể ghi chú</Typography>}

                                            </AccordionDetails>
                                        </Accordion>

                                    </Stack>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Divider />
                        <Paper>
                        </Paper>
                    </Form>
                </FormikProvider>

            </Drawer>
        </>
    );
})
